var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade modal-fullwidth",
      attrs: { tabindex: "-1" },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("table", { staticClass: "table table-hover history-table" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.recentHistory, function (entry, index) {
                  return _c(
                    "tr",
                    { key: entry.hash + entry.interface.viewedResults },
                    [
                      _c("td", [
                        _c("strong", [_vm._v(_vm._s(index + 1) + ".")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-muted",
                          staticStyle: { "padding-left": "0" },
                        },
                        [
                          _c("small", [
                            _vm._v(
                              _vm._s(
                                new Date(entry.timestamp).toLocaleString(
                                  "nl-NL",
                                  {
                                    hour12: false,
                                    //year: '2-digit',
                                    month: "2-digit",
                                    day: "2-digit",
                                    hour: "numeric",
                                    minute: "numeric",
                                  }
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            entry.interface.viewedResults === "hits"
                              ? "Hits"
                              : entry.interface.viewedResults === "docs"
                              ? "Documents"
                              : entry.interface.viewedResults
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "history-table-contain-text",
                          attrs: {
                            title:
                              entry.displayValues.pattern.substring(0, 1000) ||
                              undefined,
                          },
                        },
                        [_vm._v(_vm._s(entry.displayValues.pattern))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "history-table-contain-text",
                          attrs: {
                            title:
                              entry.displayValues.filters.substring(0, 1000) ||
                              undefined,
                          },
                        },
                        [_vm._v(_vm._s(entry.displayValues.filters))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "history-table-contain-text",
                          attrs: {
                            title:
                              entry.view.groupBy
                                .concat(entry.view.groupByAdvanced)
                                .join(" ") || "-",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              entry.view.groupBy
                                .concat(entry.view.groupByAdvanced)
                                .join(" ") || "-"
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-default",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.load(entry)
                                },
                              },
                            },
                            [_vm._v("Search")]
                          ),
                          _vm._v(" "),
                          _vm._m(2, true),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                            },
                            [
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openShareUrl(entry)
                                      },
                                    },
                                  },
                                  [_vm._v("Copy as link")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.downloadAsFile(entry)
                                      },
                                    },
                                  },
                                  [_vm._v("Download as file")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.remove(index)
                                      },
                                    },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.clearHistoryVisible = true
                                      },
                                    },
                                  },
                                  [_vm._v("Delete all")]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm.recentHistory.length < _vm.history.length
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.shownOlderEntries += 5
                      },
                    },
                  },
                  [_vm._v("Load more")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _vm.importUrlVisible
              ? _c(
                  "form",
                  {
                    staticClass: "history-table-import-url",
                    attrs: { name: _vm.uid + "_import" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.importFromUrl.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "input-group",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c("input", {
                          ref: "importUrlInput",
                          staticClass: "form-control",
                          attrs: {
                            type: "url",
                            autocomplete: "off",
                            autofocus: "",
                            placeholder: "Copy your url here",
                          },
                        }),
                        _vm._v(" "),
                        _vm._m(3),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.importUrlError
                      ? _c("div", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.importUrlError)),
                        ])
                      : _vm._e(),
                  ]
                )
              : _c(
                  "button",
                  {
                    staticClass: "btn btn-link btn-open-import",
                    on: {
                      click: function ($event) {
                        _vm.importUrlVisible = !_vm.importUrlVisible
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "fa fa-lg fa-plus" }),
                    _vm._v(" Import from a link"),
                  ]
                ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  name: "closeSettings",
                  "data-dismiss": "modal",
                },
              },
              [_vm._v("Close")]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.isSharingUrl
        ? _c(
            "form",
            {
              staticClass: "history-popup",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.closeShareUrl.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "history-popup-content modal-content" },
                [
                  _c("input", {
                    ref: "shareUrlInput",
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      autocomplete: "off",
                      autofocus: "",
                      readonly: "",
                    },
                    domProps: { value: _vm.sharingUrl },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clearHistoryVisible
        ? _c(
            "form",
            {
              staticClass: "history-popup",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  _vm.clearHistoryVisible = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "history-popup-content modal-content" },
                [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _vm._v(
                      "\n\t\t\t\tAre you sure you want to clear your search history?\n\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modal-footer",
                      staticStyle: { "justify-content": "flex-end" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.clearHistory },
                        },
                        [_vm._v("Clear")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.clearHistoryVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title" }, [_vm._v("History")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "30px;" } }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "70px;" } }),
        _vm._v(" "),
        _c("th", { attrs: { width: "90px;" } }, [_vm._v("Results")]),
        _vm._v(" "),
        _c("th", [_vm._v("Pattern")]),
        _vm._v(" "),
        _c("th", [_vm._v("Filters")]),
        _vm._v(" "),
        _c("th", [_vm._v("Grouping")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "115px" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-default dropdown-toggle",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("span", { staticClass: "caret" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-btn" }, [
      _c(
        "button",
        { staticClass: "btn btn-primary", attrs: { type: "submit" } },
        [_vm._v("Import url")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [
        _vm._v("Clear search history"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }